// Follows "HR Design rules.md": GEN, DIS
import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { CheckIcon } from 'lucide-react';

import { cn } from '@/lib/utils';

/**
 * 16px checkbox (Component Map › Checkboxes): `input` border, primary when checked with a
 * `primary-foreground` check (works in both themes), grey tokens when disabled. The `after` box widens the
 * hit area to 26px (GEN-10).
 */
function Checkbox({ className, ...props }: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        "peer relative size-4 shrink-0 rounded-sm border border-input shadow-sm transition-[color,background-color,border-color,box-shadow] duration-fast ease-standard outline-none after:absolute after:-inset-[5px] after:content-['']",
        'focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background',
        'data-[state=checked]:border-primary data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground',
        'data-[state=indeterminate]:border-primary data-[state=indeterminate]:bg-primary data-[state=indeterminate]:text-primary-foreground',
        'disabled:cursor-not-allowed disabled:shadow-none disabled:!border-disabled-border disabled:!bg-disabled disabled:!text-disabled-foreground',
        'aria-invalid:border-destructive aria-invalid:focus-visible:ring-destructive',
        className
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="grid place-content-center text-current transition-none"
      >
        <CheckIcon className="size-3.5" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
